import Button from './Button';

// §2.6 Empty state: one sentence saying what to do, and one primary action.
export default function EmptyState({ message, action }) {
  return (
    <div className="ui ui-state">
      <p className="ui-state__msg">{message}</p>
      {action && <Button variant="primary" icon={action.icon} onClick={action.onClick}>{action.label}</Button>}
    </div>
  );
}
